export default {"src":"/_next/static/media/terraform-logo-mark_on-light.85742624.svg","height":72,"width":50,"blurWidth":0,"blurHeight":0};